import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchCountries'
})

export class SearchCountriesPipe implements PipeTransform {

  transform(pipeData, pipeModifier): any {
    if (pipeModifier != 'COUNTRY') {
      return pipeData.filter(eachItem => {
        if (eachItem['fields']['countries']) {
          return (
            eachItem['fields']['countries'].includes(pipeModifier)
          )
        }
      });
    } else {
      return pipeData
    }
  }
}